import React from "react";
import "./admin.scss";
import AdminHeader from "../../components/header-dashboard-admin/AdminHeader";
import closeIcon from "../../assets/xblack.svg";

import "./admin.scss";
import Corousel from "../../components/Tag/corousel/Corousel";

function Admin() {
  return (
    <div className="admin">
      <AdminHeader />
      <div className="wrapper-corousel mt-3 mb-3">
        <Corousel />
      </div>
    </div>
  );
}

export default Admin;
